module.exports = __webpack_public_path__ + "static/assets/de1b3e675e8471510c39fc8d9bbadc4d.png";